import { SxProps } from '@mui/material';
import { defaultContainerStyling, getListPageMaxHeight } from '../../styles/sxStyling';
import { appZIndex } from '../../styles/zIndex';

export const tableContainerSx: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  maxHeight: getListPageMaxHeight(),
  overflow: 'hidden',
  width: '100%',
};
export const tableWrapperContainerSx: SxProps = {
  ...defaultContainerStyling,
  display: 'flex',
  overflow: 'hidden',
  width: '100%',
  borderRadius: 3,
  border: '1px solid var(--border-color)',
};

export const droppableRowSx = {
  display: 'flex',
  flex: 1,
  overflow: 'auto',
};

export const columnBoxSx = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  borderRight: '1px solid rgb(251, 251, 251)',
  backgroundColor: '#fff',
};

export const sortTableCellSx = {
  borderRight: '1px solid rgb(251, 251, 251)',
  position: 'sticky',
  top: 0,
  zIndex: appZIndex.raised,
  backgroundColor: 'var(--table-header-bg)',
  '&:hover .drag-icon': {
    visibility: 'visible',
  },
};

export const sortCellInnerSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  cursor: 'pointer',
};

export const dragIconSx = {
  minWidth: 20,
  display: 'flex',
  alignItems: 'center',
  mr: 1,
};

export const swapIconSx = {
  display: 'flex',
  alignItems: 'center',
  minWidth: 20,
  ml: 0.5,
  visibility: 'hidden',
};
